/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon24Solid = forwardRef('MediaUiAPlayPauseIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.066 10.508 3.664 4.133C2.498 3.418 1 4.257 1 5.625v12.75c0 1.367 1.498 2.207 2.664 1.492l10.402-6.375a1.75 1.75 0 0 0 0-2.984Z" }),
        React.createElement("path", { d: "M21 5.5a1.5 1.5 0 0 1 3 0v13a1.5 1.5 0 1 1-3 0v-13Z" }),
        React.createElement("path", { d: "M17.5 4A1.5 1.5 0 0 0 16 5.5v13a1.5 1.5 0 1 0 3 0v-13A1.5 1.5 0 0 0 17.5 4Z" })));
});
